<template>
    <div>
        <CoachAside
            :coach="coach"
            :opening-hours="openingHours"
            :opening-hours-duration="coach.month_opening_hours_duration"
        />

        <!-- aside -->
        <div class="panel-wrapper">
            <div class="coach-header">
                <MatrixPanel :coach="coach" />
            </div>

            <div class="user-tabs-wrapper">
                <nav class="nav-tabs">
                    <ul class="tabs-list container">
                        <li class="tab-rating active">
                            <a data-toggle="tab" href="#tab-rating" @click="tab = 'rating'">{{ __('Rating') }}</a>
                        </li>

                        <li class="tab-availability-change">
                            <a data-toggle="tab" href="#tab-availability-change" @click="tab = 'availability-change'">
                                {{ __('Change of availability') }}
                            </a>
                        </li>

                        <li class="tab-vacation">
                            <a data-toggle="tab" href="#tab-vacation" @click="tab = 'vacation'">
                                {{ __('Holiday') }}
                                <span v-if="coach.active_vacation">
                                    {{ __('to') }}
                                    {{
                                        coach.active_vacation && moment(coach.active_vacation.end_date).format('D. M.')
                                    }}
                                </span>
                            </a>
                        </li>

                        <li class="tab-substitute">
                            <a data-toggle="tab" href="#tab-substitute" @click="tab = 'substitute'">
                                {{ __('Substitute') }}
                                <span v-if="coach.active_substitute">
                                    {{ __('to') }}
                                    {{
                                        coach.active_substitute
                                            && moment(coach.active_substitute.end_date).format('D. M.')
                                    }}
                                </span>
                            </a>
                        </li>

                        <li class="tab-availability">
                            <a data-toggle="tab" href="#tab-availability" @click="tab = 'availability'">
                                {{ __('Calendar of consultations') }}
                            </a>
                        </li>

                        <li class="tab-availability">
                            <a data-toggle="tab" href="#tab-chat" @click="tab = 'chat'">
                                {{ __('Messages') }}
                            </a>
                        </li>
                    </ul>
                </nav>

                <div class="table-layout table-patient table-clinical">
                    <div class="container">
                        <div class="tab-content">
                            <div id="tab-rating" class="tab-pane fade active in">
                                <TabReviews :coach="coach" />
                            </div>
                            <div id="tab-availability-change" class="tab-pane fade">
                                <TabAvailabilityChange :coach="coach" />
                            </div>
                            <div id="tab-vacation" class="tab-pane fade">
                                <TabVacation :coach="coach" />
                            </div>
                            <div id="tab-substitute" class="tab-pane fade">
                                <TabSubstitute :coach="coach" />
                            </div>
                            <div id="tab-availability" class="tab-pane fade">
                                <TabAvailability :coach="coach" />
                            </div>
                            <div id="tab-chat" class="tab-pane fade">
                                <TabChat :coach="coach" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CoachArchiveModal :coach="coach" v-if="!coach.deleted_at"></CoachArchiveModal>
    </div>
</template>

<script>
import MatrixPanel from './MatrixPanel'
import CoachAside from './CoachAside'
import TabReviews from './TabReviews'
import TabAvailabilityChange from './TabAvailabilityChange/TabAvailabilityChange'
import TabAvailability from './TabAvailability'
import TabVacation from './TabVacation/TabVacation'
import TabSubstitute from './TabSubstitute/TabSubstitute'
import TabChat from './TabChat'
import CoachArchiveModal from './CoachArchiveModal'

export default {
    components: {
        CoachAside,
        MatrixPanel,
        TabReviews,
        TabAvailabilityChange,
        TabAvailability,
        TabVacation,
        TabSubstitute,
        TabChat,
        CoachArchiveModal
    },
    props: {
        coach: {
            type: Object,
            required: true
        },
        openingHours: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            tab: 'rating'
        }
    },
    mounted() {
        $(() => {
            $('.item-therapist').addClass('active')

            var elementOffset = $('.nav-tabs').offset().top

            if(window.User.is_impersonating) {
                elementOffset = elementOffset - 70
            }

            $(window).scroll(function() {
                const scrolled = $(document).scrollTop()

                if (scrolled > elementOffset - 60) {
                    $('.nav-tabs').addClass('fixed')
                } else {
                    $('.nav-tabs').removeClass('fixed')
                }
            })

            $('.info-secondary').scroll(function() {
                const heightAsideInfo = $('.info-secondary').prop('scrollHeight')

                if ((heightAsideInfo + 284) > $(window).outerHeight()) {
                    const scrolled = $('.info-secondary').scrollTop()

                    if (scrolled > 0) {
                        $('.user-detail-aside').addClass('off-canvas')
                    } else {
                        $('.user-detail-aside').removeClass('off-canvas')
                    }
                }
            })

            this.readUrl()

            const $tab = $('li.active a[data-toggle="tab"]')

            if ($tab) {
                const tabNameFragments = $tab.attr('href').split('-')

                tabNameFragments.shift()

                this.tab = tabNameFragments.join('-')
            }
        })
    },
    methods: {
        readUrl() {
            if (window.location.hash) {
                const $el = $('a[href="' + window.location.hash + '"]')

                if ($el) {
                    $el.click()
                    window.location.hash = ''
                }
            }
        }
    }
}
</script>
